exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "resellers-feature {\n  display: block; }\n  resellers-feature default-select {\n    padding-right: 1rem; }\n    @media screen and (max-width: 768px) {\n      resellers-feature default-select {\n        padding-right: 0; } }\n  resellers-feature .inputs {\n    padding-bottom: 1rem; }\n  resellers-feature .reseller:not(:last-child), resellers-feature .inputs {\n    border-bottom: 1px solid #dfdcdc; }\n  resellers-feature .reseller .info {\n    padding-bottom: .5rem; }\n", ""]);

// exports
